import React from 'react';
import { internationalText, Language } from '../../../internationalText';
import { ColorPalette } from '../../../Palette/ColorPalette';

export interface CILegendProps {
  language: Language;
  palette: ColorPalette;
}
export const CILegend: React.FC<CILegendProps> = ({ language, palette }) => {
  return (
    <div className="flex justify-between items-center">
      <div className="pr-4"> {internationalText.chart.competitors_by_topic.bad[language]}</div>
      <div className="w-[200px] h-[10px] rounded-full flex flex-row">
        {[...palette.performanceScale].reverse().map((color, index) => (
          <div
            key={index}
            className={`
              flex-1 h-[10px]
              ${index === 0 && 'rounded-l-full'}
              ${index === palette.performanceScale.length - 1 && 'rounded-r-full'}
            `}
            style={{ backgroundColor: color }}
          />
        ))}
      </div>
      <div className="pl-4"> {internationalText.chart.competitors_by_topic.good[language]}</div>
    </div>
  );
};

export default CILegend;
